export enum PdfViewerViewModeFlag {
    Annotation = 'annotationMode',
    Compare = 'compareMode',
    EmailsAndOffice = 'emailsAndOfficeMode',
    Error = 'errorMode',
    Images = 'imageMode',
    Loading = 'loadingMode',
    View = 'viewMode',
}

export enum RotationDirection {
    clockwise = 'clockwise',
    counterclockwise = 'counterclockwise',
}

export const isValidViewMode = (
    viewMode: string | PdfViewerViewModeFlag,
): viewMode is PdfViewerViewModeFlag => {
    return Object.values(PdfViewerViewModeFlag).includes(viewMode as PdfViewerViewModeFlag);
};
